import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bf87cb0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf87cb0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrderBoxServe: require('/drone/src/components/OrderBox/OrderBoxServe.vue').default})
